import React from 'react';
import PropTypes from 'prop-types';
import Navigateleft from '@nerdwallet/react-icon/gizmo/Navigateleft';

var BackButton = function BackButton(_ref) {
  var history = _ref.history;

  function navigateBack(e) {
    e.preventDefault();
    var fallback = '/credit-cards'; // If there is no browser history, send them to the portal

    if (window.history.length <= 1) {
      window.location.pathname = fallback;
    } else {
      history.goBack();
    }

    return false;
  }

  return /*#__PURE__*/React.createElement("a", {
    href: "/rewards-credit-cards",
    className: "back",
    onClick: navigateBack
  }, /*#__PURE__*/React.createElement(Navigateleft, {
    className: "icon navigateleft"
  }), /*#__PURE__*/React.createElement("span", null, "Back"));
};

BackButton.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func
  })
};
export default BackButton;